import { render, staticRenderFns } from "./ProductInformation.vue?vue&type=template&id=70979089&scoped=true&"
import script from "./ProductInformation.vue?vue&type=script&lang=js&"
export * from "./ProductInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProductInformation.vue?vue&type=style&index=0&id=70979089&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70979089",
  null
  
)

export default component.exports